var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:{
        'is-select':_vm.isSelelct===_vm.value,
        'is-disabled-option':_vm.isDisabled
    },on:{"click":function($event){return _vm.handleChooseLi($event)}}},[_vm._v(_vm._s(_vm.label))])}
var staticRenderFns = []

export { render, staticRenderFns }